export default "__VITE_ASSET__C05I9Cwo__"